"use strict";

// Class definition
var KTLayoutSearch = function() {
    // Private variables
    var element;
    var formElement;
    var mainElement;
    var resultsElement;
    var wrapperElement;
    var emptyElement;

    var preferencesElement;
    var preferencesShowElement;
    var preferencesDismissElement;
    
    var advancedOptionsFormElement;
    var advancedOptionsFormShowElement;
    var advancedOptionsFormCancelElement;
    var advancedOptionsFormSearchElement;
    
    var searchObject;

    // Private functions
    var processs = function(search) {
        // fill search elem

        APIPost('/api/local/search', {q: $(`[data-kt-search-element="input"]`).val()}, function (res) {
            $("#search_results_show").html('');
            if (res.status == 200) {

                // Vars for changing input
                var result_users = "";
                var result_products = "";
                var result_customers = "";
                var result_transactions = "";
                var result_write_off = "";

                // Users
                for (var i = 0; i < res.users.length; i++) {

                    var user_name = res.users[i].firstname;

                    if (user_name == "" || user_name == null) {
                        user_name = "-";
                    }

                    result_users += "<div style='margin-bottom: 7px;'><a style='color: black;' href='/employees/edit/" + res.users[i].id + "'>" + user_name + "</a></div>";

                }

                // Products
                for (i = 0; i < res.products.length; i++) {
                    var name = res.products[i].name;
                    var price = res.products[i].sell_price;
                    var category = res.products[i].category ? res.products[i].category.name : "";
                    var variation = res.products[i].price_search.value;


                    if (name == "" || name == null) {
                        name = "-";
                        price = "-";
                        category = "-";
                        variation = "-";
                    }
                    if (variation == "") {

                        result_products += "<div style='margin-bottom: 7px'><a style='color: black;' href='/catalogue/products/edit/" + res.products[i].id + "'>" + name + "</a><a style='color: black; float: right;'>€" + price / 100 + "</a><br><a style='color: grey;'>" + category + "</a></div>";
                    } else {
                        result_products += "<div style='margin-bottom: 7px'><a style='color: black;' href='/catalogue/products/edit/" + res.products[i].id + "'>" + name + "</a><a style='color: black; float: right;'>€" + price / 100 + " - €" + variation / 100 + "</a><br><a style='color: grey;'>" + category + "</a></div>";

                    }
                }
                // customers
                for (i = 0; i < res.customers.length; i++) {
                    var name = res.customers[i].name;


                    if (name == "" || name == null) {
                        name = "-";
                    }

                    result_customers += "<div style='margin-bottom: 7px'><a style='color: black;' href='/customers/edit/" + res.customers[i].id + "'>" + name + "</a></div>";

                }
                for (i = 0; i < res.transactions.length; i++) {
                    var number = res.transactions[i].number;
                    var total = res.transactions[i].total;
                    var type = res.transactions[i].search.payment_type.type;

                    if (number == "" || number == null) {
                        number = "-";
                        total = "-";
                        type = "-";
                    }

                    result_transactions += "<div style='margin-bottom: 7px'><a style='color: black;' href='/sales/pos/pdf/" + number + "'>Kassabon " + number + "</a><a style='color: black; float: right;'>€" + total / 100 + "</a><br><a style='color: grey;'>" + type + "</a></div>";
                }

                for (i = 0; i < res.write_off.length; i++) {

                    var number = res.write_off[i].number;
                    var price = res.write_off[i].sub_total;
                    var method = res.write_off[i].search_payment.payment_type.name;
                    var type = res.write_off[i].search_payment.payment_type.type;
                    var id = res.write_off[i].id;


                    if (number == "" || number == null) {
                        number = "-";
                        price = "-";
                        method = "-";
                        type = "-";
                        id = "-";
                    }

                    result_write_off += "<div style='margin-bottom: 7px'><a style='color: black;' href='/sales/mutations/pdf/" + id + "'>Afboeking " + number + "</a><a style='color: black; float: right;'>€" + price / 100 + "</a><br><a style='color: grey;'>" + method + "</a></div>";
                }

                if (
                    result_users === "" &&
                    result_products === "" &&
                    result_customers === "" &&
                    result_transactions === "" &&
                    result_write_off === ""
                ) {
                    noResults();
                } else {
                    if (result_users !== ""){
                        $("#search_results_show").append(
                            `<h3 class="fs-5 text-muted m-0 pt-5 pb-5" data-kt-search-element="category-title">${language.users}</h3>` + result_users
                        )
                    }

                    if (result_products !== ""){
                        $("#search_results_show").append(
                            `<h3 class="fs-5 text-muted m-0 pt-5 pb-5" data-kt-search-element="category-title">${language.products}</h3>` + result_products
                        )
                    }

                    if (result_customers !== ""){
                        $("#search_results_show").append(
                            `<h3 class="fs-5 text-muted m-0 pt-5 pb-5" data-kt-search-element="category-title">${language.customers}</h3>` + result_customers
                        )
                    }

                    if (result_transactions !== ""){
                        $("#search_results_show").append(
                            `<h3 class="fs-5 text-muted m-0 pt-5 pb-5" data-kt-search-element="category-title">${language.transactions}</h3>` + result_transactions
                        )
                    }

                    if (result_write_off !== ""){
                        $("#search_results_show").append(
                            `<h3 class="fs-5 text-muted m-0 pt-5 pb-5" data-kt-search-element="category-title">${language.writeoff}</h3>` + result_write_off
                        )
                    }

                    results();
                }



            } else {
                // no results
                noResults();
            }
        });


        function noResults() {
            // Hide recently viewed
            mainElement.classList.add('d-none');
            // Hide results
            resultsElement.classList.add('d-none');
            // Show empty message
            emptyElement.classList.remove('d-none');
            // Complete search
            search.complete();
        }

        function results(){
            // Hide recently viewed
            mainElement.classList.add('d-none');
            // Show results
            resultsElement.classList.remove('d-none');
            // Hide empty message
            emptyElement.classList.add('d-none');
            // Complete search
            search.complete();
        }
    }

    var clear = function(search) {
        // Show recently viewed
        mainElement.classList.remove('d-none');
        // Hide results
        resultsElement.classList.add('d-none');
        // Hide empty message 
        emptyElement.classList.add('d-none');
    }    

    var handlePreferences = function() {
        // Preference show handler
        // preferencesShowElement.addEventListener('click', function() {
        //     wrapperElement.classList.add('d-none');
        //     preferencesElement.classList.remove('d-none');
        // });

        // Preference dismiss handler
        // preferencesDismissElement.addEventListener('click', function() {
        //     wrapperElement.classList.remove('d-none');
        //     preferencesElement.classList.add('d-none');
        // });
    }

    var handleAdvancedOptionsForm = function() {
        // Show
        // advancedOptionsFormShowElement.addEventListener('click', function() {
        //     wrapperElement.classList.add('d-none');
        //     advancedOptionsFormElement.classList.remove('d-none');
        // });

        // Cancel
        // advancedOptionsFormCancelElement.addEventListener('click', function() {
        //     wrapperElement.classList.remove('d-none');
        //     advancedOptionsFormElement.classList.add('d-none');
        // });

        // Search
        // advancedOptionsFormSearchElement.addEventListener('click', function() {
        //
        // });
    }

    // Public methods
	return {
		init: function() {
            // Elements
            element = document.querySelector('#kt_header_search');

            if (!element) {
                return;
            }

            wrapperElement = element.querySelector('[data-kt-search-element="wrapper"]');
            formElement = element.querySelector('[data-kt-search-element="form"]');
            mainElement = element.querySelector('[data-kt-search-element="main"]');
            resultsElement = element.querySelector('[data-kt-search-element="results"]');
            emptyElement = element.querySelector('[data-kt-search-element="empty"]');

            preferencesElement = element.querySelector('[data-kt-search-element="preferences"]');
            preferencesShowElement = element.querySelector('[data-kt-search-element="preferences-show"]');
            preferencesDismissElement = element.querySelector('[data-kt-search-element="preferences-dismiss"]');

            advancedOptionsFormElement = element.querySelector('[data-kt-search-element="advanced-options-form"]');
            advancedOptionsFormShowElement = element.querySelector('[data-kt-search-element="advanced-options-form-show"]');
            advancedOptionsFormCancelElement = element.querySelector('[data-kt-search-element="advanced-options-form-cancel"]');
            advancedOptionsFormSearchElement = element.querySelector('[data-kt-search-element="advanced-options-form-search"]');
            
            // Initialize search handler
            searchObject = new KTSearch(element);

            // Search handler
            searchObject.on('kt.search.process', processs);

            // Clear handler
            searchObject.on('kt.search.clear', clear);

            // Custom handlers
            handlePreferences();
            handleAdvancedOptionsForm();            
		}
	};
}();

// On document ready
KTUtil.onDOMContentLoaded(function() {
    KTLayoutSearch.init();
});